import { render } from "./ModalAvisoReenvioEmail.vue?vue&type=template&id=57012490&scoped=true"
import script from "./ModalAvisoReenvioEmail.vue?vue&type=script&lang=js"
export * from "./ModalAvisoReenvioEmail.vue?vue&type=script&lang=js"

import "./ModalAvisoReenvioEmail.vue?vue&type=style&index=0&id=57012490&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-57012490"]])

export default __exports__